import { SkeletonLoaderModule } from 'src/app/shared/skeleton-loader/skeleton-loader.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2StateDeclaration, UIRouterModule } from '@uirouter/angular';
import { RoleEntityScopePageComponent } from './role-entity-scope-page.component';
import { FormsModule } from '@angular/forms';

const states: Ng2StateDeclaration[] = [
  {
    name: 'missioncontrol.roleentityscope',
    url: '/roleentityscope',
    component: RoleEntityScopePageComponent,
    data: {
      requireLogin: true
    }
  }
];

@NgModule({
  declarations: [RoleEntityScopePageComponent],
  imports: [
    CommonModule,
    FormsModule,
    SkeletonLoaderModule,
    UIRouterModule.forChild({ states })
  ],
  entryComponents: [RoleEntityScopePageComponent]
})
export class RoleEntityScopePageModule { }
